import { RuleCreateModel } from './rule-create-model';

export class RuleCreateModelWithUserId extends RuleCreateModel {
  userId: string|null;
}
